import { render } from "./products-imported.vue?vue&type=template&id=310fa35b"
import script from "./products-imported.vue?vue&type=script&setup=true&lang=js"
export * from "./products-imported.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/add-products/products-imported.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "310fa35b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('310fa35b', __exports__)) {
    console.log('reload')
    api.reload('310fa35b', __exports__)
  }
  
  module.hot.accept("./products-imported.vue?vue&type=template&id=310fa35b", () => {
    console.log('re-render')
    api.rerender('310fa35b', render)
  })

}


export default __exports__